<app-slider
  #slider
  [items]="collection.items"
  [title]="collection.name"
  [id]="collection.id"
  [collection]="collection"
  [preview]="true"
  [showActions]="true"
  [indentTop]="true"
  [loadedView]="'HOME'"
  (titleClicked)="queryCollection()">
  <ng-template appSliderActions>
    <app-slider-view-more-button
      *ngIf="showPreview(collection)"
      (click)="queryCollection()"></app-slider-view-more-button>
  </ng-template>
</app-slider>
